// extracted by mini-css-extract-plugin
export var contact = "PersonCard-module--contact--4f3de";
export var contactEmail = "PersonCard-module--contact-email--3d6b1";
export var contactTel = "PersonCard-module--contact-tel--60488";
export var description = "PersonCard-module--description--beb24";
export var fadeIn = "PersonCard-module--fadeIn--6b759";
export var imageBox = "PersonCard-module--image-box--8c4b2";
export var person = "PersonCard-module--person--1f458";
export var personEmail = "PersonCard-module--person-email--99b04";
export var personImage = "PersonCard-module--person-image--5a629";
export var personImageImg = "PersonCard-module--person-image-img--31970";
export var personInfo = "PersonCard-module--person-info--448d7";
export var personPosition = "PersonCard-module--person-position--56b2e";
export var personSignature = "PersonCard-module--person-signature--930e7";
export var personTel = "PersonCard-module--person-tel--aa697";
export var qrCode = "PersonCard-module--qr-code--bd904";
export var qrCodeBox = "PersonCard-module--qr-code-box--ac255";
export var show = "PersonCard-module--show--95c60";